export default {
      id: "chats-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#chats-usage",
      toString: function () {
        return this.url;
      }
    }